import React from "react";
import StarIcon from "@mui/icons-material/Star";
import Image from "next/image";
import Card from "@mui/material/Card";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import CardContent from "@mui/material/CardContent";
import { JOB_LISTING_LINK } from "@/constastants/Constant";

const WorkingWithUs = () => {
  return (
    <div className="flex flex-col items-center  w-full lg:h-auto bg-red  mb-10 lg:mb-[8rem] lg:rounded-[4px] lg:pt-[2.2rem] pb-4 lg:pb-0 ">
      <div className="px-5 py-2 lg:px-[2.5rem] lg:pb-[2.5rem] flex flex-col gap-10 justify-between lg:flex-row items-center w-full mt-[2rem] lg:mt-[0]">
        <div className="mb-4 md:mb-0  text-left  ">
          <h5 className="text-white text-xs md:text-[13px] lg:pb-1 lg:font-medium font-mukta">
            Join Elchemy
          </h5>
          <div className="w-[4.6rem] h-[0.5px] bg-white mt-1 mb-4"></div>
          <h2 className="text-white text-[28px] lg:text-[32px] lg:pb-2 font-Mukta">
            Work With Us!
          </h2>

          <h4 className="text-[#FFF] text-[13px]  md:mb-2 md:mukta md:w-full md:text-left md:font-thin!">
            Join Elchemy's dynamic team and be part of our journey to
            revolutionize global chemical solutions. Embrace innovation,
            challenge the status quo, and shape the future with us!
          </h4>
          <h4 className="text-[#FFF] text-[13px]  md:mb-2 md:mukta md:w-full md:text-left md:font-thin!">
            Send your resume to{" "}
            <a
              href="mailto:hr@elchemy.com"
              rel="noopener noreferrer"
              className="underline font-normal hover:text-white"
            >
              {" "}
              hr@elchemy.com{" "}
            </a>
            or{""}
            <a
              href="/contact-elchemy"
              rel="noopener noreferrer"
              className="underline text font-normal hover:text-white"
            >
              {" "}
              Contact Us{" "}
            </a>
          </h4>

          <div className=" text-left flex flex-col md:flex-row  gap-4 mt-4">
            <a
              href="https://tally.so/r/3xJz4v"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button
                type="button"
                className="py-3 px-16 border-2 w-full md:w-full border-white text-red bg-white rounded-[4px] mt-4 md:mt-0 md:ml-auto lg:font-mukta  font-[500]  hover:bg-transparent hover:text-white transition-all "
              >
                Join Us
              </button>
            </a>
            <a
              href={JOB_LISTING_LINK}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="border-2 p-2 py-3 px-4  border-[#fff] justify-center md:flex  align-center text-center w-full  md:w-full lg:h-full  lg:ml-[0]   rounded-[3px] text-[white]  hover:bg-white hover:text-red transition-all">
                View open roles
                {/* <LinkedInIcon /> */}
              </div>
            </a>
          </div>
        </div>
        <div className="flex gap-4 ">
          <div className="">
            <a
              href="https://www.glassdoor.co.in/Overview/Working-at-Elchemy-EI_IE7105247.11,18.htm"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Card className="md:w-[150px]  lg:w-[200px] h-[10rem]  rounded-[5px]">
                <CardContent className="">
                  <div className="flex flex-col justify-center items-center">
                    <Image
                      src="https://storage.googleapis.com/elchemy-dev/1707136417.svg"
                      width={85}
                      height={72}
                      className="relative  h-16 sm:h-18 mb-1 "
                      alt="brand-logo"
                    />
                    <div className="w-[90px] rounded-[4px] my-2.5 py-2 bg-[#F1F2F2] ">
                      <StarIcon style={{ color: "#FFC500" }} /> 4.2/5
                    </div>
                    {/* <div className="text-[12px]  font-semibold text-[#666666]">
                      1,230 User Reviews
                    </div> */}
                  </div>
                </CardContent>
              </Card>
            </a>
          </div>
          {/* <a
            href="https://www.ambitionbox.com/overview/elchemy-overview"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Card className="  md:w-[150px]  lg:w-[200px] h-[10rem]  rounded-[5px] ">
              <CardContent>
                <div className=" flex flex-col justify-center items-center">
                  <Image
                    src="https://storage.googleapis.com/elchemy-dev/1707136495.svg"
                    width={85}
                    height={72}
                    className="relative  h-16 sm:h-18 mb-1 "
                    alt="brand-logo"
                  />
                  <div className="w-[90px] rounded-[4px] my-2.5 py-2 bg-[#F1F2F2] ">
                    <StarIcon style={{ color: "#FFC500" }} /> 4.9/5
                  </div>
                 
                </div>
              </CardContent>
            </Card>
          </a> */}
        </div>
      </div>
    </div>
  );
};

export default WorkingWithUs;
